import * as actionTypes from '../actions'

const initialState = {
  listproducts: [],
  loading: false,
  productInfo: null,
  firstDescription: null,
  secondDescription: null,
  redirectNotFound:false,
  relatedProducts:[]
}

const productReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.LOAD_DATA_PRODUCT: {
      return {
        ...state,
        listproducts: action.payload.data
          ? action.payload.data
          : action.payload,
        loading: false
      }
    }
    case actionTypes.LOAD_DATA_PRODUCT_INFO: {
      return {
        ...state,
        productInfo: action.payload,
        fistDescription: action.payload.description
          ? action.payload.description.substring(0, 200)
          : '',
        secondDescription: action.payload.description
          ? action.payload.description.substring(
              201,
              action.payload.description.lenght
            )
          : '',
        // loading: true
      }
    }
    case actionTypes.TOGGLE_LOADING_DATA_PRODUCT: {
      
      if(action.payload){
        return {
          ...initialState,
          loading: action.payload
        }  
      }
      else{
        return {
          ...state,
          loading: action.payload
        }
      }
      
    }
    case actionTypes.DEFAULT_DATA_PRODUCT: {
      return initialState
    }
    case actionTypes.REDIRECT_NOT_FOUND: {
      return {
        ...state,
        redirectNotFound: action.payload
      }
    }

    case actionTypes.SET_RELATED_PRODUCT: {
      return {
        ...state,
        relatedProducts:action.payload
      }
    }
    default: {
      return state
    }
  }
}

export default productReducer
